import {
    TRACK_REMOVE_SUCCESS,
    TRACKS_SAGA_GET_TRACKS,
    TRACKS_SAGA_GET_USER_TRACKS,
    TRACKS_SAGA_SYNC_TVT,
} from '../actionTypes'

export const getTracks = trackType => ({ type: TRACKS_SAGA_GET_TRACKS, trackType })
export const syncTvt = payrollPeriod => ({ type: TRACKS_SAGA_SYNC_TVT, payrollPeriod })
export const getTracksByUserAndDate = (
    userId,
    date,
) => ({ type: TRACKS_SAGA_GET_USER_TRACKS, userId, date })

export const trackRemoved = () => ({ type: TRACK_REMOVE_SUCCESS })
